export default "__VITE_ASSET__DoPVh466__"